import React, { useState } from 'react'
import { string, bool } from 'prop-types'
import classnames from 'classnames'
import { setSnoopyUrl } from '../../../utils/url_parser'

const Image = ({ src = '', placeholderWithBorderRadius, alt = '', isBig = false,
  noOptimization = false, crop = true, ...rest }) => {
  const [srcLink, onSrcLinkChange] = useState(false)
  const imageClass = classnames({
    'image__placeholder': !srcLink,
    'image__placeholder--rounded': placeholderWithBorderRadius
  })
  const params = new URLSearchParams(src || rest['data-src'])
  const fitToContainer = params.get('fit_to_container') === 'true'
  const sourceData = [
    { device: 'mobile-s', media: '(max-width: 374px)' },
    { device: 'mobile-m', media: '(max-width: 648px)' },
    { device: 'mobile-l', media: '(max-width: 767px)' },
    { device: 'tablet-p', media: '(max-width: 896px)' },
    { device: 'tablet-l', media: '(max-width: 1023px)' },
    { device: 'desktop', media: '(min-width: 1024px)' }
  ]

  // For gallery images, we can optimize later
  if (noOptimization) {
    return (
      <div itemProp={'imageObject'} itemScope itemType={'http://schema.org/ImageObject'}
        className={classnames('image__container', { 'image__container--fit': fitToContainer })}>
        <meta itemProp='name' content={alt || src || rest['data-src']} />
        {(src || rest['data-src']) && <img itemProp={'contentUrl'} alt={alt}
          onLoad={() => onSrcLinkChange(true)} src={src} {...rest} />}
        <div className={imageClass} />
      </div>
    )
  }

  const baseSrcOptions = {
    url: src || rest['data-src'],
    device: 'desktop',
    crop: crop,
    isBig
  }

  return (
    <div itemProp={'imageObject'} itemScope itemType={'http://schema.org/ImageObject'}
      className={classnames('image__container', { 'image__container--fit': fitToContainer })}>
      <meta itemProp='name' content={alt || baseSrcOptions.url} />
      {(baseSrcOptions.url) && <picture style={{ height: '100%' }}>
        {sourceData.map((source, index) =>
          <source type='image/webp'
            key={index}
            // eslint-disable-next-line max-len
            srcSet={`${setSnoopyUrl({ ...baseSrcOptions, device: source['device'] })}, ${setSnoopyUrl({ ...baseSrcOptions, device: source['device'], isRetina: true })} 2x`}
            media={source['media']} />
        )}
        <img srcSet={`${setSnoopyUrl(baseSrcOptions)}, ${setSnoopyUrl({ ...baseSrcOptions, isRetina: true })} 2x`}
          itemProp={'contentUrl'} onLoad={() => onSrcLinkChange(true)}
          src={`${setSnoopyUrl(baseSrcOptions)}`} alt={alt} {...(isBig && { fetchpriority: 'high' })}
          style={{ '--large-img': `url(${setSnoopyUrl({ ...baseSrcOptions, isBig: true })})` }}
          {...rest} />
      </picture>}
      <div className={imageClass} />
    </div>
  )
}

Image.propTypes = {
  src: string,
  placeholderWithBorderRadius: bool,
  alt: string,
  isBig: bool,
  crop: bool,
  noOptimization: bool
}

export default Image
